// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contact-module--wrapper--1WQo8","tekstWrapper":"contact-module--tekstWrapper--fCT4_","tekst":"contact-module--tekst--12rc9","logos":"contact-module--logos--f3dVn"};